import React from 'react';

// An item's readable text (sanitized when saved) and images, for the Handbook and the Council portal.
function ReadableContent({ html, images = [], title }) {
  return (
    <>
      {html && <div className="handbook-content" dangerouslySetInnerHTML={{ __html: html }} />}
      {images.length > 0 && (
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
          {images.map((image, index) => (
            <img
              key={image.key || image.url}
              src={image.url}
              alt={`${title} ${index + 1}`}
              className="w-full rounded-lg border border-border cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => window.open(image.url, '_blank')}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default ReadableContent;
